import { ShareIcons } from '@/core/components/ShareIcons';
import { CheckMark } from '@/core/components/CheckMark';

import {
  CheckMarkWrapper,
  DonateLink,
  DonateLinkWrapper,
  ShareIconsWrapper,
  ThankYouHeadline,
  WantMoreText,
  Wrapper,
} from './ThankYouWrapper.styles';

interface ThankYouWrapperProps {
  buttonColor: string;
  children: React.ReactNode;
  isDonateButton: boolean;
  isFullScreen?: boolean;
  linkDonate: string | null;
  name: string;
  socialShareButtonEnabled: boolean;
  textcolor: string;
  uuid?: string | Array<string>;
}

export const ThankYouWrapper = ({
  buttonColor,
  children,
  isDonateButton,
  isFullScreen,
  linkDonate,
  name,
  socialShareButtonEnabled,
  textcolor,
  uuid,
}: ThankYouWrapperProps) => (
  <Wrapper $isFullScreen={isFullScreen}>
    <CheckMarkWrapper>
      <CheckMark backgroundColor={textcolor} />
    </CheckMarkWrapper>
    <ThankYouHeadline>{name}</ThankYouHeadline>
    {children}
    {isDonateButton && linkDonate && (
      <DonateLinkWrapper>
        <DonateLink
          backgroundcolor={buttonColor}
          href={linkDonate.startsWith('http://') || linkDonate.startsWith('https://') ? linkDonate : `https://${linkDonate}`}
          rel="noreferrer"
          textcolor={textcolor}
          target="_blank"
        >
          Donate
        </DonateLink>
      </DonateLinkWrapper>
    )}
    {socialShareButtonEnabled && typeof uuid === 'string' && (
      <>
        <WantMoreText>Want to do some more? Share this page on your social media</WantMoreText>
        <ShareIconsWrapper>
          <ShareIcons
            textcolor={buttonColor}
            customIcons
            uuid={uuid}
          />
        </ShareIconsWrapper>
      </>
    )}
  </Wrapper>
);

ThankYouWrapper.defaultProps = {
  uuid: null,
};
